import React, { useEffect } from 'react';
import { Tab } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';

import Page from '../../components/Page/Page';
import StatefulTabs from '../../components/StatefulTabs/StatefulTabs';
import Title from '../../components/Title/Title';
import { useUserProfile } from '../../hooks/reduxHooks';
import { getPermissionsForAssets } from './ApprovalQueue.helpers';
import CodeInBoxAssetsTab from './views/CodeInBoxAssetsTab';
import DPReviewTab from './views/DPReviewTab';
import EventAssetsTab from './views/EventAssetsTab.js';
import MarketingAssetsTab from './views/MarketingAssetsTab.js';
import PackagingAssetsTab from './views/PackagingAssetsTab.js';
import DigitalCodeRequests from './views/DigitalCodeRequestsTab';

import './ApprovalQueue.css';


const CODE_IN_BOX_TAB = 'code-in-box';
const DECLARED_PRICE_TAB = 'declared-price';
const MARKETING_EVENT_TAB = 'marketing-events';
const MARKETING_TAB = 'marketing';
const PACKAGING_TAB = 'packaging';
const WSP_REQUEST_TAB = 'wsp-requests';
const DC_REQUEST_TAB = 'dc-requests';

export const ApprovalQueue = () => {
	const userProfile = useUserProfile();
	const history = useHistory();
	const location = useLocation();
	const {
		showMarketingTab,
		showPackagingTab,
		showCodeInBoxTab,
		showMarketingEventTab,
		showDCRequestTab,
		showDeclaredPriceTab,
	} = getPermissionsForAssets(userProfile);

	// redirect defunct WSP request tab to DC request tab
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (params.get('tab') === WSP_REQUEST_TAB) {
			params.set('tab', DC_REQUEST_TAB);
			history.replace({ pathname: location.pathname, search: params.toString() });
		}
	}, [location.search]);

	return (
		<div className="ApprovalQueue">
			<Page>
				<Title title="Approval Queue" />
				<div className="Page__fill-space">
					<StatefulTabs
						className="ApprovalQueue__tabs"
						transition={false}
						retainPageState
					>
						{showMarketingTab && (
							<Tab
								eventKey={MARKETING_TAB}
								title="Marketing Assets"
								className="Page__fill-space"
							>
								<MarketingAssetsTab eventKey={MARKETING_TAB} />
							</Tab>
						)}
						{showPackagingTab && (
							<Tab
								eventKey={PACKAGING_TAB}
								title="Packaging Assets"
								className="Page__fill-space"
							>
								<PackagingAssetsTab eventKey={PACKAGING_TAB} />
							</Tab>
						)}
						{showCodeInBoxTab && (
							<Tab
								eventKey={CODE_IN_BOX_TAB}
								title="Code-In-Box Assets"
								className="Page__fill-space"
							>
								<CodeInBoxAssetsTab eventKey={CODE_IN_BOX_TAB} />
							</Tab>
						)}
						{showMarketingEventTab && (
							<Tab
								eventKey={MARKETING_EVENT_TAB}
								title="Marketing Event Assets"
								className="Page__fill-space"
							>
								<EventAssetsTab eventKey={MARKETING_EVENT_TAB} />
							</Tab>
						)}
						{showDCRequestTab && (
							<Tab
								eventKey={DC_REQUEST_TAB}
								title="Code-in-Box Price Requests"
								className="Page__fill-space"
							>
								<DigitalCodeRequests eventKey={DC_REQUEST_TAB} />
							</Tab>
						)}
						{showDeclaredPriceTab && (
							<Tab
								eventKey={DECLARED_PRICE_TAB}
								title="Declared Price Requests"
								className="Page__fill-space"
							>
								<DPReviewTab eventKey={DECLARED_PRICE_TAB} />
							</Tab>
						)}
					</StatefulTabs>
				</div>
			</Page>
		</div>
	);
};

export default ApprovalQueue;
